import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { TrustCharter } from '@/components/employee/TrustCharter';

export default function Welcome() {
  const navigate = useNavigate();

  const acknowledge = () => {
    localStorage.setItem('pulse:welcomed', '1');
    navigate('/app/employee', { replace: true });
  };

  return (
    <main className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-lg space-y-8 py-10">
        <header className="space-y-2 text-center">
          <h1 className="text-3xl font-heading font-semibold">Welcome to CultureLens</h1>
          <p className="text-muted-foreground">
            Before you start, here\u2019s exactly what we will and won\u2019t do with what you share.
          </p>
        </header>

        <TrustCharter />

        <Button size="lg" className="w-full" onClick={acknowledge}>
          I understand \u2014 let\u2019s start
        </Button>
        <p className="text-xs text-muted-foreground text-center">
          You can read this any time at <span className="font-medium">Trust Center</span>.
        </p>
      </div>
    </main>
  );
}
